import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "panel__scroll" }

import ArrowLeftSvg from '@/assets/arrow-left.svg';

// Components
import VPanel from './VPanel.vue';
import VButton from './VButton.vue';

// Other

import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'VPanelLayer',
  props: {
    header: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    navigation: { type: Boolean, default: false },
},
  emits: ['update:visible'],
  setup(__props, { emit: __emit }) {

// Svg
const { t } = useI18n();
const emit = __emit;


function open() {
    emit('update:visible', true);
}

function close() {
    emit('update:visible', false);
}

return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createBlock(VPanel, {
        key: 0,
        class: "panel--layer panel--navigation",
        onClose: close
      }, {
        default: _withCtx(() => [
          _createVNode(VButton, {
            class: "panel__button panel__button--back",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowLeftSvg)),
              _createElementVNode("span", null, _toDisplayString(_unref(t)('go-back')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default", {
              close: close,
              open: open,
              visible: __props.visible
            })
          ])
        ]),
        _: 3
      }))
    : _createCommentVNode("", true)
}
}

})